/**
 * Transform trip data from snake_case (database) to camelCase (frontend)
 * @param {object} trip - Trip object with snake_case keys
 * @returns {object} Trip object with camelCase keys
 */
export function transformTripData(trip) {
  if (!trip) return null;

  return {
    ...trip,
    // Transform snake_case to camelCase
    startDate: trip.start_date || trip.startDate,
    endDate: trip.end_date || trip.endDate,
    tripType: trip.trip_type || trip.tripType,
    createdAt: trip.created_at || trip.createdAt,
    updatedAt: trip.updated_at || trip.updatedAt,
    userId: trip.user_id || trip.userId,
    sharedLink: trip.shared_link || trip.sharedLink,
    allowLikes: trip.allow_likes !== undefined ? trip.allow_likes : trip.allowLikes,
    allowComments: trip.allow_comments !== undefined ? trip.allow_comments : trip.allowComments,
    budgetExpected: trip.budget_expected || trip.budgetExpected,
    budgetActual: trip.budget_actual || trip.budgetActual,
    ownerFeedback: trip.ownerFeedback || trip.owner_feedback || null,
    activityCount: trip.activity_count || trip.activityCount,
    tripStory: trip.trip_story || trip.tripStory || null
  };
}
